import React from 'react';
import { AccountPanelTypes } from '../AccountPanelTypes';
import { FontAwesomeIcon } from '../../../utilities/iconLoader/FontAwesomeIcon';

export const AccountIconHelper = ({
  icon,
  size,
  color,
}: AccountPanelTypes.TIconHelper) => {
  return (
    <FontAwesomeIcon
      iconClassName={icon}
      iconContextProps={{
        className: `has-text-${color}`,
        style: {
          fontSize: `${size}`,
        },
      }}
    />
  );
};
